import { render, staticRenderFns } from "./ExpertisesAvb.vue?vue&type=template&id=0616e92f"
import script from "./ExpertisesAvb.vue?vue&type=script&lang=js"
export * from "./ExpertisesAvb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports